export enum CloseReason {
    Accepted,
    Auto,
    ByUser
}
